export default __webpack_public_path__ + "static/promo-l5-img-2f67ec7657aa7a197fe3d889bbfafc6b.png";